import Dialogue from "./dialogue";

export default Dialogue;
